import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=6c291a4b"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shimoyamadayuu/Documents/github/management-site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c291a4b')) {
      api.createRecord('6c291a4b', component.options)
    } else {
      api.reload('6c291a4b', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=6c291a4b", function () {
      api.rerender('6c291a4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/reserve/Index.vue"
export default component.exports